import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

interface HamburgerMenuV2StyleProps {
  expanded: boolean
}

const useStyles = makeStyles<Theme, HamburgerMenuV2StyleProps>(theme => ({
  myInfoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  myInfoDetailsColumn: {
    paddingLeft: 16,
    display: 'grid',
    gridGap: 4,
    paddingRight: 20,
    gridTemplateRows: 'auto auto',
    maxWidth: 160,

    '& > label:nth-child(1)': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: theme.size.lg
    },

    '& > label:nth-child(2)': {
      color: 'grey',
      fontSize: theme.size.base
    }
  },

  myActionsContainer: {
    display: 'flex',
    alignItems: 'center'
  },

  icon: {
    fontSize: theme.size.xl,
    cursor: 'pointer'
  },

  push: {
    marginLeft: 'auto',
    marginRight: 0
  },

  close: {
    paddingLeft: 20
  },

  expand: {
    transform: ({ expanded }) => (expanded ? `rotate(180deg)` : `rotate(0deg)`),
    transition: `transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`
  },

  avatar: {
    width: 36,
    height: 36
  },

  mySubInfoContainer: {},

  unorderedList: {
    margin: '0',
    padding: '0',
    paddingTop: 15
  },

  navigationSeparator: {
    borderBottom: 'solid 1px #C6C6C6',
    marginTop: 24,
    marginLeft: '-24px',
    marginRight: '-24px'
  },

  footer: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    bottom: 'calc(0px + 20px)',
    right: '20px',

    '& label': {
      marginLeft: 8,
      fontSize: theme.size.base
    }
  },

  footerLogo: {
    width: 46,
    height: 46
  }
}))

export default useStyles
